<template>
	<div class="login-wrap">
		<div class="header_logo">
			<el-image style="cursor:pointer" class="logo" @click="$router.push('/')" :src="logo" fit="fill">
				<div slot="error" class="image-slot">
					<i class="el-icon-picture-outline"></i>
				</div>
			</el-image>
		</div>
		<div class="minddle">
			<div class="formBox">
				<div class="login_text">注册</div>
				<el-form :model="ruleForm" :inline="true" status-icon :rules="rules" ref="ruleForm"
					class="demo-ruleForm" label-width="100px">
					<el-form-item prop="companyName">
						<el-input type="text" v-model="ruleForm.companyName" autocomplete="off" placeholder="公司名称">
						</el-input>
					</el-form-item>
					<!-- <el-form-item prop="credOrgUscc">
						<el-input type="text" v-model="ruleForm.credOrgUscc" autocomplete="off" placeholder="统一社会信用代码">
						</el-input>
					</el-form-item>
					<el-form-item prop="legalPerson">
						<el-input type="text" v-model="ruleForm.legalPerson" autocomplete="off" placeholder="法人">
						</el-input>
					</el-form-item>
					<el-form-item prop="idCard">
						<el-input type="text" v-model="ruleForm.idCard" autocomplete="off" placeholder="法人身份证号">
						</el-input>
					</el-form-item>
					<el-form-item prop="legalPersonPhone">
						<el-input type="text" v-model="ruleForm.legalPersonPhone" autocomplete="off" placeholder="联系电话">
						</el-input>
					</el-form-item> -->
					<el-form-item label="营业执照" prop="avatar">
						<el-upload name="files" class="avatar-uploader"
							:action="`${$baseUrl}/custom/xunyou/api/common/upload`" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
							<el-image v-if="ruleForm.avatar" class="avatar" :src="ruleForm.avatar">
							</el-image>
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
						<!-- <p class="text" style="color: #ef7171;">请保证图片格式正确（png、jpg），且不超过2MB</p> -->
					</el-form-item>
					<!-- 添加地址时展示 -->
					<el-form-item prop="areaid">
						<el-cascader v-model="cascaderAreaValue" ref="cascaderAddr" class="cascaderArea"
							placeholder="地址" :props="{ checkStrictly: true }" :options="getprovince"
							@change="areaHandleChange">
						</el-cascader>
					</el-form-item>

					<!-- <el-form-item prop="address">
						<el-input type="text" v-model="ruleForm.address" autocomplete="off" placeholder="详细地址">
						</el-input>
					</el-form-item> -->


					<el-form-item prop="username">
						<el-input type="text" v-model="ruleForm.username" autocomplete="off" placeholder="手机号">
						</el-input>
					</el-form-item>
					<el-form-item prop="password">
						<el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="密码">
						</el-input>
					</el-form-item>
					<el-form-item prop="passwordComfirm">
						<el-input type="password" v-model="ruleForm.passwordComfirm" autocomplete="off"
							placeholder="确认密码"></el-input>
					</el-form-item>
					<el-form-item class="codeImgText" prop="code">
						<!-- <el-input  v-model="ruleForm.code" autocomplete="off" placeholder="验证码"></el-input> -->
						<el-input type="text" placeholder="验证码" v-model="ruleForm.code">
							<template slot="append">
								<div @click="refreshCode" class="codeImg">
									<s-identify :identifyCode="identifyCode"></s-identify>
								</div>
								<!-- <el-image @click="flashImg" class="codeImg" title="点击刷新验证码" :src="require('@/assets/images/logo.png')" fit="fill">
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                              </div>
                        </el-image> -->
							</template>
						</el-input>
					</el-form-item>
					<el-form-item class="codePhoneText" prop="codePhone">
						<!-- <el-input type="password" v-model="ruleForm.codePhone" autocomplete="off" placeholder="输入短信验证码"></el-input> -->
						<el-input type="text" placeholder="输入短信验证码" v-model="ruleForm.codePhone">
							<template slot="append">
								<el-button class="getMessageText" :disabled='codeDisabled' @click="getsendSms"
									v-if="!isShowButton">获取短信验证码</el-button>
								<p class="getMessageText" v-if="isShowButton">{{count}}秒后重新获取</p>
							</template>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitForm()">注册</el-button>
					</el-form-item>
				</el-form>
				<!-- <p class="agrreUserText">点击注册表示同意 <a target="_blank" @click="$router.push('#/userAgreement')"> 用户协议</a> <a href="#/userAgreement">商家入驻</a></p> -->
				<p class="agrreUserText">点击注册表示同意 <router-link to="/userAgreement"> 用户协议</router-link>
				</p>
				<div class="textBox">
					<a class="passtext" @click="$router.push('/retrievePassword')">登录遇到问题</a>
					<el-divider direction="vertical"></el-divider>
					<a class="creatText" @click="$router.push('/login')">我已注册,现在登录</a>
				</div>
			</div>
		</div>
		<div class="footer_info">
			<p class="text-center" style="line-height: 30px;">{{informations.copyrightInformation}}<br>
				<a :href="informations.icpUrl" target="_blank">{{informations.icp}}</a>
			</p>
		</div>
	</div>
</template>
<script type="text/ecmascript-6">
	import {
		login,
		sendSms,
		register,
		copyRight,
		setImage,
		addresslist,
		address_add
	} from "@/api/xunyou";
	import {
		setCookie,
		getCookie,
		delCookie
	} from '../utils/util'
	import SIdentify from '@/components/sidentify'
	import md5 from 'js-md5'
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		name: 'login',
		components: {
			SIdentify
		},
		data() {
			// 验证 统一社会信用代码
			let Tyshyxdm = (rule, code, callback) => {
				console.log(code);
				let isPass = true // 是否验证通过，默认通过，为true
				let errorMessage = '' // 错误信息
				const reg = /^\w\w\d{6}\w{9}\w$/ // 18位及正则校验

				// 空值直接返回false
				if (!code) {
					isPass = false
					errorMessage = '请输入所属企业的社会统一信用代码！'
				} else if (code.length !== 18 || !reg.test(code)) {
					isPass = false
					errorMessage = '不是有效的统一社会信用代码！'
				} else {
					const codeOrigin = '0123456789ABCDEFGHJKLMNPQRTUWXY'; // 统一社会信用代码可用字符 不含I、O、S、V、Z
				 const weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30,
					28]; // 统一社会信用代码相对应顺序的加权因子

					let ci; // 统一社会信用代码相应顺序的值
					let wi; // 统一社会信用代码相应顺序的加权因子
					let total = 0; // 计算结果

					// 数值与加权因子相乘之和
					for (let i = 0; i < code.length - 1; i++) {
						ci = codeOrigin.indexOf(code[i]);
						wi = weightedfactors[i];
						total += ci * wi;
					}

					// 最后一位校验
					let logicCheckCode = 31 - (total % 31);
					if (logicCheckCode === 31) logicCheckCode = 0;
					logicCheckCode = codeOrigin[logicCheckCode];
					if (logicCheckCode !== code.slice(17)) {
						isPass = false
						errorMessage = '不是有效的统一社会信用代码！'
					}
				}
				if (isPass) {
					callback();
				} else {
					callback(new Error(errorMessage));
				}
			}
			let getVCode = (rule, value, callback) => {
				console.log(value);
				var sId = value;
				let message = "";
				if (sId.length == 15) {
					if (!/^\d{14}(\d|x)$/i.test(sId)) {
						message = "你输入的身份证长度或格式错误";
						console.log(message);
						callback(new Error(message));
					} else {
						sId = sId.substr(0, 6) + '19' + sId.substr(6, 9);
						sId += getVCode(sId);
					}
				}

				function getVCode(CardNo17) {
					var Wi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1);
					var Ai = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
					var cardNoSum = 0;
					for (var i = 0; i < CardNo17.length; i++) cardNoSum += CardNo17.charAt(i) * Wi[i];
					var seq = cardNoSum % 11;
					return Ai[seq];
				}
				var aCity = {
					11: "北京",
					12: "天津",
					13: "河北",
					14: "山西",
					15: "内蒙古",
					21: "辽宁",
					22: "吉林",
					23: "黑龙江",
					31: "上海",
					32: "江苏",
					33: "浙江",
					34: "安徽",
					35: "福建",
					36: "江西",
					37: "山东",
					41: "河南",
					42: "湖北",
					43: "湖南",
					44: "广东",
					45: "广西",
					46: "海南",
					50: "重庆",
					51: "四川",
					52: "贵州",
					53: "云南",
					54: "西藏",
					61: "陕西",
					62: "甘肃",
					63: "青海",
					64: "宁夏",
					65: "新疆",
					71: "台湾",
					81: "香港",
					82: "澳门",
					91: "国外"
				};

				var iSum = 0;
				var info = "";
				console.log(sId);
				if (!/^\d{17}(\d|x)$/i.test(sId)) {
					message = "你输入的身份证长度或格式错误";
					callback(new Error(message));
				}
				sId = sId.replace(/x$/i, "a");
				if (aCity[parseInt(sId.substr(0, 2))] == null) {
					message = "你的身份证地区非法";
					callback(new Error(message));
				}
				var sBirthday = sId.substr(6, 4) + "-" + Number(sId.substr(10, 2)) + "-" + Number(sId.substr(12, 2));
				var d = new Date(sBirthday.replace(/-/g, "/"));
				if (sBirthday != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) {
					message = "身份证上的出生日期非法";
					callback(new Error(message));
				}
				// for(var i = 17;i>=0;i --) iSum += (Math.pow(2,i) % 11) * parseInt(sId.charAt(17 - i),11) ;
				// if(iSum%11!=1){
				// 	this.message =  "你输入的身份证号非法";
				// 	console.log('--4');
				// 	return false;
				// }
				callback()
			}



			return {
				logo: '',
				informations: {},
				isShowButton: false,
				identifyCode: "",
				identifyCodes: "1234567890",
				//注册
				ruleForm: {
					companyName: '',
					credOrgUscc: '',
					legalPerson: '',
					idCard: '',
					legalPersonPhone: '',
					avatar: '',
					//username和password默认为空
					username: '',
					password: '',
					passwordComfirm: '',
					code: '',
					codePhone: '',
					isNotCode: true,
					areaid: ''
				},
				bizId: '',
				sendTime: '',
				count: '',
				timer: null,
				sendCode: true,
				codeDisabled: false,
				//rules前端验证
				rules: {

					username: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							pattern:  /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
							required: true,
							message: '请输入正确的手机号',
							trigger: 'blur',
						}
					],
					// password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
					code: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur',
						validator: (rule, value, callback) => {
							console.log(rule, value, '验证码校验')
							if (value === '') {
								callback(new Error('请输入验证码'));
							} else if (this.identifyCode !== value) {
								this.ruleForm.code = '',
									this.refreshCode()
							} else {
								callback();
							}
						}
					}],
					codePhone: [{
						required: true,
						message: '输入短信验证码',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						//  message: "不能为空",
						trigger: ["blur"],
						validator: (rule, value, callback) => {
							let reg = new RegExp(
								/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
							let result = reg.test(value);
							if (value == '') {
								callback(new Error('不能为空'));
							} else if (!result) {
								callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
							} else {
								callback();
							}
						}
					}],
					passwordComfirm: [{
						required: true,
						// message: "不能为空",
						trigger: ["blur"],
						validator: (rule, value, callback) => {
							let regs = new RegExp(
								/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{6,16}$/)
							let results = regs.test(value);
							if (value == '') {
								callback(new Error('不能为空'));
							} else if (!results) {
								callback(new Error('密码长度6~16位，其中数字，字母和符号至少包含两种'));
							} else if (value != this.ruleForm.password) {
								callback(new Error('两次密码不一致'));
							} else {
								callback();
							}
						}
					}],
					companyName: [{
							required: true,
							message: "请输入公司名称",
							trigger: ["blur"]
						},
						{
							min: 3,
							max: 90,
							message: '请输入完整的公司名称',
							trigger: 'blur'
						}
					],
					credOrgUscc: [{
						validator: Tyshyxdm,
						trigger: ["blur"]
					}, ],
					legalPerson: [{
						required: true,
						message: "请输入法人",
						trigger: ["blur"]
					}, ],
					idCard: [{
						validator: getVCode,
						trigger: ["blur"]
					} ],
					legalPersonPhone: [{
						required: true,
						message: "请输入联系电话",
						trigger: ["blur"]
					}, ],
					avatar: [{
						required: true,
						message: "请上传营业执照",
						trigger: ["blur", "change"]
					}, ],
					// businessLicenseUrl:[{ required: true, message: "请上传营业执照", trigger: ["blur"] },],
					areaid: [{
						required: true,
						message: '请选择地址',
						trigger: ["blur"]
					}],

					address: [{
						required: true,
						message: "请输入详细地址",
						trigger: ["blur"]
					}, ],
				},

				businessLicense: '', //上传图片
				dialogVisible: false,
				disabled: false,
				cascaderAreaValue: [], //地址
				businessLicenseUrl: '',
				avatar: '',
				areaid: '',
				areaText: ''
			}
		},
		computed: {
			...mapState(["getprovince"]),
		},
		// 创建完毕状态(里面是操作)
		created() {
			// this.$message({
			//   message: '账号密码及验证码不为空即可',
			//   type: 'success'
			// })
			// // 获取图形验证码
			// this.getcode()
			// // 获取存在本地的用户名密码
			// this.getuserpwd()
			this.getImagelogo()
			this.geTCopyright()
		},
		mounted() {
			this.identifyCode = "";
			this.makeCode(this.identifyCodes, 4);

		},
		// 里面的函数只有调用才会执行
		methods: {
			beforeAvatarUpload(file) {
				const isJPG = file.type == 'image/jpeg' || file.type == 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			//   营业执照
			handleAvatarSuccess(res, file) {
				console.log(res, URL.createObjectURL(file.raw))
				this.businessLicenseUrl = URL.createObjectURL(file.raw) // 用来图片预览的
				this.ruleForm.avatar = res.url;
				console.log(this.ruleForm.avatar);
				// this.$forceUpdate();
				// this.sizeForm.businessLicense =URL.createObjectURL(file.raw). substring(URL.createObjectURL(file.raw).lastIndexOf("/"));
			},
			// 输入地址选择
			areaHandleChange(value, form, thsAraeCode) {
				this.$refs["cascaderAddr"].getCheckedNodes();
				this.ruleForm.areaid = value[value.length - 1];
				console.log(this.ruleForm);
				console.log(value);
				// console.log(thsAraeCode);
				// this.thsAraeCode = this.$refs['cascaderAddr'].currentLabels
				console.log(this.cascaderAreaValue, this.thsAraeCode, '输入地址选择');
				const checkedNode = this.$refs["cascaderAddr"].getCheckedNodes();
				console.log(checkedNode[0].data.label); //获取当前点击节点的label值
				console.log(checkedNode[0].pathLabels); //获取由label组成的数组
				this.areaText = checkedNode[0].pathLabels;
			},

			handleRemove(file) {
				console.log(file);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleDownload(file) {
				console.log(file);
			},
			// 获取logo
			getImagelogo() {
				setImage().then(res => {
					if (res.code == 0) {
						this.logo = res.rows[0].pcLogo
					}
				})
			},
			// 获取版权名称
			geTCopyright() {
				copyRight().then(res => {
					if (res.code == 0) {
						this.informations = res.rows[0]
						if (this.informations.powstatus == 1) {
							this.$router.push('/erroPage')
						} else {
							this.$store.commit('getcopyRight', this.informations)
						}
					}
				}).catch(err => {
					this.$message.error('查询失败,请稍后再试!')
				})
			},
			// 获取用户名密码
			// getuserpwd() {
			//   if (getCookie('user') != '' && getCookie('pwd') != '') {
			//     this.ruleForm.username = getCookie('user')
			//     this.ruleForm.password = getCookie('pwd')
			//     this.rememberpwd = true
			//   }
			// },

			//验证码
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min);
			},

			refreshCode() {
				console.log('点击验证码刷新')
				this.identifyCode = "";
				this.makeCode(this.identifyCodes, 4);
			},

			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[
						this.randomNum(0, this.identifyCodes.length)
					];
				}
			},

			// 获取短信验证码
			getsendSms() {
				if (this.ruleForm.username == '') {
					this.$message({
						type: 'info',
						message: '请输入手机号'
					});
					return
				}
				if (!/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(this.ruleForm.username)) {
					this.$message({
						type: 'info',
						message: '请输入正确格式手机号'
					});
					return
				}

				if (this.ruleForm.code == '') {
					this.$message({
						type: 'info',
						message: '请输入验证码'
					});
					return
				}
				this.codeDisabled = true
				console.log(this.ruleForm.username);
				const TIME_COUNT = 60;
				if (!this.timer) {
					this.isShowButton = true
					this.count = TIME_COUNT;
					this.sendCode = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.sendCode = true;
							this.isShowButton = false;
							this.codeDisabled = false;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000);
				}
				sendSms({
						TemplateCode: 'SMS_201652431',
						phoneNumbers: this.ruleForm.username
					}).then((res) => {
						//  this.toast(res.Message);
						if (res.code !== 0) {
							this.$message.error(res.msg);
							return;
						} else {
							this.$message({
								type: 'success',
								message: '发送成功!'
							});
							//发送成功
							const bizId = res.data.BizId;
							this.bizId = bizId;
							var nowDate = new Date();
							var year = nowDate.getFullYear();
							var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) :
								nowDate.getMonth() + 1;
							var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
								.getDate();

							this.sendTime = year + '' + month + '' + day;

							const TIME_COUNT = 60;
							if (!this.timer) {
								this.isShowButton = true
								this.count = TIME_COUNT;
								this.sendCode = false;
								this.timer = setInterval(() => {
									if (this.count > 0 && this.count <= TIME_COUNT) {
										this.count--;
									} else {
										this.sendCode = true;
										this.isShowButton = false
										this.codeDisabled = false
										clearInterval(this.timer);
										this.timer = null;
									}
								}, 1000);
							}
						}
					})
					.catch((err) => {
						this.loading = false;
						// this.$message.error("发送短信验证码失败，请稍后再试！");
					});
			},

			//注册
			submitForm() {
				console.log("注册");
				if (this.ruleForm.username == '') {
					this.$message({
						type: 'info',
						message: '请输入手机号'
					});
					return
				}
				if (!/^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(this.ruleForm.username)) {
					this.$message({
						type: 'info',
						message: '请输入正确格式手机号'
					});
					return
				}

				this.$refs.ruleForm.validate(valid => {
					const req = {
						username: this.ruleForm.username,
						photo: this.ruleForm.username,
						password: this.ruleForm.password,
						// bizId: this.bizId,
						sendTime: this.sendTime,
						validateCode: this.ruleForm.codePhone,

						companyName: this.ruleForm.companyName,
						credOrgUscc: this.ruleForm.credOrgUscc,
						legalPerson: this.ruleForm.legalPerson,
						idCard: this.ruleForm.idCard,
						legalPersonPhone: this.ruleForm.legalPersonPhone,
						businessLicenseUrl: this.ruleForm.avatar,
						provinceAreaId: this.cascaderAreaValue[0],
						cityAreaId: this.cascaderAreaValue[1],
						areaId: this.cascaderAreaValue[2],
						areaText: this.areaText,
						address: this.ruleForm.address
					}
					if (valid) {
						register(req)
							.then((res) => {
								if (res.code == 0) {
									// this.$router.push({ path: `/initialPasswordSet?userId=${res.data||0}` }) // // 暂时不跳修改密码
									this.$router.push({
										path: `/login`
									})
									this.$message({
										type: 'success',
										message: '注册成功!'
									});
								} else {
									this.$message.error(res.msg);
								}
							})
							.catch((err) => {
								this.loading = false;
								this.$message.error("注册失败，请稍后再试！");
							});
					} else {
						console.log('----5');
						return false
					}
				})
			},

			// 获取验证码
			// flashImg(){
			//   console.log('点击验证码刷新')
			// }
		}
	}
</script>

<style scoped lang='less'>
	/deep/ .logo img {
		width: 255px;
		height: 52px;
	}

	.login-wrap {
		box-sizing: border-box;
		width: 100%;
		height: 100%;

		.header_logo {
			padding: 30px 140px;
			margin: auto;
		}

		.minddle {
			background: url("~@/assets/img/bigbackground.png") no-repeat;
			position: relative;
			background-repeat: no-repeat;
			background-size: cover;
			height: 670px;

			.formBox {
				//  width: 20%;
				width: 450px;
				height: 550px;
				background: white;
				position: absolute;
				right: 180px;
				top: 50%;
				padding: 40px 50px;
				transform: translate(0, -50%);
				padding: 40px 50px;
				overflow-y: scroll;

				.codeImgText {
					.el-image.codeImg {
						width: 150px;
						height: 100%;
						cursor: pointer;
					}

					/deep/.el-input-group__append {
						padding: 0;
					}

				}

				.codePhoneText {
					.getMessageText {
						display: block;
						color: white;
						font-size: 16px;
						width: 170px;
						cursor: pointer;
						text-align: center;
					}

					.getMessageText.el-button.is-disabled:hover {
						background-color: #005ea7
					}

					/deep/.el-input-group__append {
						background: #4b5bff;
						color: white;
					}

					/deep/.el-input-group__append:hover {
						background: #5d6bff;
					}

				}

				.agrreUserText {
					font-size: 14px;
					color: #979898;

					span {
						color: #333;
						cursor: pointer;
					}
				}

				.login_text {
					color: #666;
					margin-bottom: 20px;
					color: rgba(151, 152, 152, 0.6);
					font-size: 20px;
				}

				button.el-button.el-button--primary {
					width: 100%;
					background-color: #394af8;
					border-color: #394af8;
				}

				button.el-button.el-button--primary:hover {
					background-color: #409eff;
					border-color: #409eff;
				}

				.cascaderArea.el-cascader {
					width: 100%;

					/deep/input[disabled],
					/deep/input[disabled="disabled"],
					/deep/input[readonly],
					/deep/input[readonly="readonly"] {
						background-color: white;
					}
				}

				/deep/.el-input__inner {
					border: 1px solid #ccc;
				}

				/deep/.el-upload {}

				.textBox {
					text-align: right;
					font-size: 16px;

					a {
						color: #68b828;
						cursor: pointer;
					}
				}

				.avatar-uploader .el-upload {
					border: 1px dashed #d9d9d9;
					border-radius: 6px;
					cursor: pointer;
					position: relative;
					overflow: hidden;
				}

				.avatar-uploader .el-upload:hover {
					border-color: #409EFF;
				}

				.avatar-uploader .el-upload {
					border: 1px dashed #d9d9d9;
					border-radius: 6px;
					cursor: pointer;
					position: relative;
					overflow: hidden;
				}

				.avatar-uploader .el-upload:hover {
					border-color: #409EFF;
				}

				.avatar-uploader .avatar-uploader-icon {
					font-size: 28px;
					color: #8c939d;
					width: 140px;
					height: 140px;
					line-height: 140px;
					text-align: center;
					border: 1px solid #ccc;
				}

				.avatar {
					width: 160px;
					height: 160px;
					display: block;
				}
			}
		}

		.footer_info {
			text-align: center;
			font-size: 14px;
			padding: 20px;

			p.text-center {
				color: #979898;
			}
		}
	}

	.login-container {
		border-radius: 10px;
		margin: 0px auto;
		width: 350px;
		padding: 30px 35px 15px 35px;
		background: #fff;
		border: 1px solid #eaeaea;
		text-align: left;
		box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
	}

	.title {
		margin: 0px auto 40px auto;
		text-align: center;
		color: #505458;
	}

	.remember {
		margin: 0px 0px 35px 0px;
	}

	.code-box {
		text-align: right;
	}

	/deep/ .el-form-item {
		margin-bottom: 29px !important;
	}
</style>



// WEBPACK FOOTER //
// src/views/register.vue